<template>
  <div class="historical_record" :class="$store.state.historical.websql_is_show ? 'historical_sidebar_open' : ''">
    <div class="myHeader">{{$t('components_historical_record_index_2193')}}<i class="el-icon-close right_sidebar_close" @click="right_sidebar_close"></i>
    </div>
    <el-button type="primary" @click="clear_all" style="display:block;margin: 0 auto;margin-top: 5px;width: 280px;">{{$t('components_historical_record_index_2194')}}</el-button>
    <ul class="historical_record_list" v-if="has_webSQL">
      <li
        v-for="(val,i) in $store.state.historical.historical_record"
        :class="val.id === $store.state.historical.Pointer.id ? 'sele' : ''"
        :data-historical_record_id="val.id"
        @click="select_historical(val)">
        <div class="line">
          <b>{{i+1}}</b>
          <span class="right_sidebar_child_handle" :title="val.name">{{val.name}}</span>
          <span class="right_sidebar_child_handle" :title="val.time && new Date(val.time).toLocaleString()">{{val.time|time_filters}}</span>
          <!--<i class="el-icon-delete" @click.stop="del_historical(val,i)"></i>-->
        </div>

      </li>
    </ul>
    <div v-else class="no_websql_Prompt">
      <p>{{$t('components_historical_record_index_2195')}}</p>
      <p>{{$t('components_historical_record_index_2196')}}</p>
    </div>

  </div>

</template>

<script>
import i18n from '../../language/index'

  export default {
    name: "historical_record",
    data() {
      return {
        selectId: "",
        isShow: true
      };
    },
    filters: {
      time_filters(val){
        const time = new Date(val).toLocaleString();
        const end = time.split(' ')[1];
        return end;
      }
    },
    methods: {
      right_sidebar_close() {
        this.$store.commit('historical/websql_close');
      },
      select_historical(val){
        this.$store.commit('historical/set_pointer_id',val.id);
        this.$store.dispatch('historical/find_sql',{
          $message:this.$message,
          type:'Select',
          id:val.id
        }).finally(()=>{
          this.$nextTick(()=>{

            //顶部固定
            //this.templet.recount_fixed()
          })
        });
        //this.templet.find_sql(this.$message,'Select',val.id);
      },
      clear_all(){
        this.$confirm(i18n.t('components_historical_record_index_2197'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(()=>{
          const last_obj = this.$store.state.historical.historical_record[this.$store.state.historical.historical_record.length-1];
          const last_id = last_obj ? last_obj.id : null;
          if(last_id){
            this.$store.dispatch('historical/clear_all',{last_id,last_obj});
          }

        }).catch(()=>{})

      }
    },
    computed:{
      has_webSQL(){
        if(typeof openDatabase =='undefined'){
          return false;
        }
        else{
          return true;
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/historical_record/index.vue